export default __webpack_public_path__ + "static/media/record_active.f076eeb6.svg";